<template>
  <div class="min-h-screen flex flex-col h-full bg-[#F7FBFE]">
    <TsHeaderCheckout />

    <div>
      <slot />
    </div>

    <TsFooterCheckout append-class="mt-auto" />
  </div>
</template>

<script setup lang="ts">
const TsHeaderCheckout = defineAsyncComponent(() => import('~/components/TsHeaderCheckout.vue'));
const TsFooterCheckout = defineAsyncComponent(() => import('~/components/TsFooterCheckout.vue'));

</script>